const BASE_URL = 'https://baback-public-logo.s3.eu-west-3.amazonaws.com/external/';


export const getSocialIconPngUrl = (icon: string, color: 'black' | 'white' = 'black') => {
  return `${BASE_URL}${icon}-${color}.png`;
}
